import helpers from "../utils/helpers";
import Dropzone from "./dropzone";

const Forms = {
  utDropzone: null,

  init() {
    this.events();
  },

  events() {
    const usedTech = $(".used-tech");

    $("[name=used-tech-payment]").on("change", (e) => {
      if ($(e.currentTarget).prop("checked")) {
        usedTech.show().find(".disabled").removeClass("disabled");
      } else {
        usedTech.hide().find(".required").addClass("disabled");
      }
    });

    $(".form-new").on("submit", (e) => {
      e.preventDefault();

      Forms.handleSubmit($(e.currentTarget));
    });

    this.utDropzone = new Dropzone($(".form-used").find(".dropzone"));
    $(".form-used").on("submit", (e) => {
      e.preventDefault();

      Forms.handleSubmit($(e.currentTarget));
    });
  },

  handleSubmit(formEl) {
    formEl.addClass("loading");

    if (!helpers.validate(formEl)) {
      formEl.removeClass("loading");
      return;
    }

    Forms.recaptcha(formEl);
  },

  recaptcha(formEl) {
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
        Forms.post(formEl, token);
      });
    });
  },

  post(formEl, token) {
    formEl.find("button").addClass("loading");
    formEl.find(".form-status").addClass("hidden");

    const formData = new FormData(formEl[0]);
    formData.append("token", token);

    if (formEl.hasClass("form-used") && this.utDropzone) {
      formData.delete("images[]");

      const files = this.utDropzone.getExistingFiles();

      files.forEach((file) => {
        formData.append("images[]", file);
      });
    }

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    })
      .done((response) => {
        if (response.success) {
          formEl[0].reset();
          formEl.find(".errors-wrap").remove();
          formEl.find(".form-status").removeClass("error");
        } else {
          formEl.find(".form-status").addClass("error");
        }

        formEl
          .find(".form-status")
          .text(response.data.message)
          .removeClass("hidden");
      })
      .always(() => {
        formEl.removeClass("loading");
        formEl.find("button").removeClass("loading");
      });
  },
};
export default Forms;
